import React, { useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
// import "./footer.scss"
import PlaceBat2d from '../place-bat/PlaceBat2d'
import BarcodeReader from "react-barcode-reader";
import { useDispatch, useSelector } from 'react-redux';
import { SHOW_MAIN_ERROR_MODAL } from '../../../redux/errorMessageSlice';
import { SET_1D_ADVANCE_DRAW_SELECT_TIME, SET_1D_CLAIM_TICKET_ID } from '../../../redux/1d-slice/gameInfo1dSlice';
import { RESET_1D_SLICE_STATE, SET_ACTIVE_SERIES_INDEX, SET_ACTIVE_SERIES_PART_INDEX, SET_LAST_INPUT_CHANGE_RECORD, SET_PREVIEWS_ACTIVE_SERIES_DETAIL, SET_SERIES_PART_CHECKED, SET_SERIES_STORE, SelecrSeriesStore } from '../../../redux/1d-slice/seriesSlice1d';
import { setAdvanceTimeSlotCount, selectAdvaceTimeSlotCount } from '../../../redux/seriesSlice';

import { SocketState } from "../../../context/SocketProvider";

function Footer() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { socket } = SocketState()
    let seriesStore = useSelector(SelecrSeriesStore)
    const advanceTimeSlotCount = useSelector(selectAdvaceTimeSlotCount);

    // Create the downHandler with useCallback to prevent unnecessary recreations
    const downHandler = useCallback((e) => {
        let { key } = e
        if (key === 'F5') {
            e.preventDefault()
            dispatch(RESET_1D_SLICE_STATE());
            dispatch(SET_1D_ADVANCE_DRAW_SELECT_TIME([]))
        }
        if (key === 'F1') {
            navigate('ResultModal1d')
        }
        if (key === 'F3') {
            e.preventDefault();
            e.stopPropagation();

            console.log('F3 Pressed');
            console.log('Current Path:', window.location.pathname);

            navigate('reprint');
        }
        if (key === 'F2') {
            navigate('report')
        }
        if (key === 'F4') {
            navigate('cancel-ticket-1d')
        }
        if (key === 'F9') {
            navigate('advance')
        }
    }, [dispatch, navigate]);

    // Add the keydown event listener for F5, F6, etc.
    useEffect(() => {
        window.addEventListener("keydown", downHandler);

        return () => {
            window.removeEventListener("keydown", downHandler);
        }
    }, [downHandler]);

    useEffect(() => {
        document.addEventListener('keydown', event => {
            if (event.keyCode === 74 || event.keyCode === 2) {
                event.preventDefault();
                return false;
            }
        });
        return () => {
            document.removeEventListener('keydown', null)
        }
    }, [])

    let handleScan = (data) => {
        let ticket_id = data.slice(1)
        dispatch(SET_1D_CLAIM_TICKET_ID(ticket_id))
        navigate('claim-ticket')
    }

    let handleError = (err) => {
        // console.log('err: ', err);
        // dispatch(SHOW_MAIN_ERROR_MODAL('Somthing went wrong'))
        // toast.error('Somthing wrong')
    }

    let resetCode = () => {
        seriesStore.forEach((series) => {
            series.AllSeriesPartName.forEach((partName) => {
                partName.active = false
            })

            series.seriesAllfield.forEach((fields) => {
                fields.forEach(field => {

                    field.resetValue()
                })
            })
        })

        dispatch(SET_SERIES_STORE(seriesStore))
        dispatch(SET_ACTIVE_SERIES_INDEX(0))
        dispatch(SET_ACTIVE_SERIES_PART_INDEX(0))
        dispatch(SET_LAST_INPUT_CHANGE_RECORD())
        dispatch(SET_PREVIEWS_ACTIVE_SERIES_DETAIL({ lastSeriesIndex: null, lastSeriesPartIndex: null, isActiveSeriesName: false }))
        dispatch(SET_SERIES_PART_CHECKED(new Array(3).fill(false)))
        dispatch(SET_1D_ADVANCE_DRAW_SELECT_TIME([]))
    }

    return (
        <>
            <table width="100%" height="100%" border="0" align="left" style={{
                marginTop: '5px', marginBottom: '5px',
                backgroundColor: "#d9d9d9 !important"
            }}>
                <tbody>
                    <tr >
                        <th width="1%" scope="col"></th>
                        <th bgcolor="#b2a2c7" width="5%" scope="col" style={{ borderRadius: '5px', cursor: 'pointer' }} onClick={() => navigate('ResultModal1d')}>Result(F1)</th>
                        <th width="1%" scope="col"></th>
                        <th bgcolor="#db9595" width="5%" scope="col" style={{ borderRadius: '5px', cursor: 'pointer' }} onClick={() => navigate('report')}>Account(F2)</th>
                        <th width="1%" scope="col"></th>
                        <th bgcolor="#93ccdd" width="5%" scope="col" style={{ borderRadius: '5px', cursor: 'pointer' }} onClick={() => navigate('reprint')}>Reprint(F3)</th>
                        <th width="1%" scope="col"></th>
                        <th bgcolor="#f0a2d2" width="5%" scope="col" style={{ borderRadius: '5px', cursor: 'pointer' }} onClick={() => navigate('cancel-ticket-1d')}>Cancel(F4)</th>
                        <th width="1%" scope="col"></th>
                        <th
                            bgcolor="#01b0f1"
                            width="5%"
                            scope="col"
                            onClick={() => navigate('advance')}
                            style={{
                                borderRadius: '5px',
                                cursor: 'pointer',
                                position: 'relative',   // ⭐ badge ke liye
                                textAlign: 'center'
                            }}
                        >
                            Advance (F9){' '}

                            {advanceTimeSlotCount > 0 && (
                                <span
                                    style={{
                                        backgroundColor: '#cc2e2eff', // green
                                        color: '#fff',
                                        borderRadius: '50%',
                                        width: '18px',
                                        height: '18px',
                                        padding: '2px 5px',
                                        fontWeight: 'bold',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    {advanceTimeSlotCount}
                                </span>
                            )}
                        </th>

                        <th width="1%" scope="col"></th>
                        <th bgcolor="#a2da17" width="5%" scope="col" style={{ borderRadius: '5px', cursor: 'pointer' }} onClick={() => navigate('secure')}>Password</th>
                        <th width="1%" scope="col"></th>
                        <th bgcolor="#fe504f" width="5%" scope="col" style={{ borderRadius: '5px', cursor: 'pointer' }} onClick={() => {
                            dispatch(RESET_1D_SLICE_STATE());
                            dispatch(SET_1D_ADVANCE_DRAW_SELECT_TIME([]))
                            dispatch(setAdvanceTimeSlotCount(0))
                        }}>Refresh (F5)</th>
                        <th width="1%" scope="col"></th>
                        <th bgcolor="#96B2DA" width="5%" scope="col" style={{ borderRadius: '5px', cursor: 'pointer' }} onClick={() => {
                            localStorage.clear()
                            socket.disconnect()
                        }}>Logout</th>
                        <th width="1%" scope="col"></th>
                    </tr>
                </tbody>
            </table>
            {/* <BarcodeReader onError={handleError} onScan={handleScan} stopPropagation={false} preventDefault={false} /> */}
            {/* <div className='footer_container'>
        <div className='footer_button_section'>
          <div className='foot_btn_sec_sub'> */}
            {/* <th style={{ borderRadius: '5px', cursor: 'pointer' }} bgcolor="#D8E5ED" width="5%" scope="col" onClick={() => navigate('report')}>REPORT(F2)</th>
            <th style={{ borderRadius: '5px', cursor: 'pointer' }} bgcolor="#D8E5ED" width="5%" scope="col" onClick={() => navigate('resultModal2d')}>RESULT(F1)</th>
            <th style={{ borderRadius: '5px', cursor: 'pointer' }} bgcolor="#D8E5ED" width="5%" scope="col" onClick={() => navigate('claim-ticket')}>CLAIM</th>
            <th style={{ borderRadius: '5px', cursor: 'pointer' }} bgcolor="#D8E5ED" width="5%" scope="col" onClick={() => navigate('complaintModal2d')}>COMPLAINT</th> */}
            {/* <th style={{ borderRadius: '5px', cursor: 'pointer' }} bgcolor="#D8E5ED" width="5%" scope="col" onClick={() => {
                dispatch(RESET_SLICE_STATE());
                dispatch(SET_ADVANCE_DRAW_SELECT_TIME([]))
                dispatch(setAdvanceTimeSlotCount(0))

            }}>RESET(F5)</th> */}
            {/* <th style={{ borderRadius: '5px', cursor: 'pointer' }} bgcolor="#D8E5ED" width="5%" scope="col" onClick={() => navigate('reprint')}>REPRINT(F3)</th>
            <th style={{ borderRadius: '5px', cursor: 'pointer' }} bgcolor="#D8E5ED" width="5%" scope="col" onClick={() => navigate('cancel-ticket')}>CANCEL(F4)</th> */}
            {/* <PlaceBat2d key={'footer'} /> */}
            {/* </div>
          <div className='foot_total_sec'></div>
        </div>
      </div> */}
        </>
    )
}

export default Footer